<template>
  <div class="entryApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent></headComponent>
    <div style="height:48px"></div>
    <div class="parkData" v-if="setData.length > 0">
      <h2>
        <div>我的会员</div>
      </h2>
      <ul>
        <li v-for="(item,i) in setData">
          <div>
            <img :src="item.avatar" />
            <div class="info">
              <div class="A1">
                <span>{{item.username}}</span>
                <span>{{item.bindtime}}</span>
              </div>
              <div class="A2">手机号:{{item.phone}}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="none" v-if="setData.length <= 0">
      <p>暂无数据~</p>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setData:[],
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.ryUser()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      ryUser:function(){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getPeople',
          data:{
            user_id:that.userData.id
          },
          dataType:'json',
          success:function(data){
            that.setData = data.data
          }
        })

      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .entryApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .entryApp .parkData{
    width:96%;
    margin:0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px;
    padding-bottom:20px
  }

  .entryApp .parkData h2{
    font-size:16px;
    width:92%;
    margin:0 auto;
    padding:15px 0;
    border-bottom:solid 1px #fafafa
  }
  .entryApp .parkData li:last-child{
    border-bottom:none;
  }
  .entryApp .parkData li{
    border-bottom:solid 1px #EBF2FF;
    width:92%;
    margin:0 auto;
  }
  .entryApp .parkData li img{
    float:left;
    width:50px;
    height:50px;
    margin:15px 10px 10px 0px;
    border-radius:50%;
  }
  .entryApp .parkData li:after,.entryApp .parkData li .isuservip:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .entryApp .parkData li .info{
    float:left;
    width:calc(100% - 60px);
    margin-top:15px
  }
  .entryApp .parkData li .info .A1{
    font-size:15px;
    padding-bottom:7px;
    height:20px
  }
  .entryApp .parkData li .info .A1 span:last-child{
    font-size:14px;
    float:right;
    color:#555;
    margin-top:3px
  }

  .entryApp .parkData li .info .A1 span:first-child{
    float:left;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width:45%
  }
  .entryApp .parkData li .info .A2{
    font-size:14px;
    padding-bottom:5px;
    color:#999;
  }

  .entryApp .parkData li .isuservip{
    border:2px dashed #ffd700;
    margin:15px 0;
    border-radius:6px;
    position:relative;
    float:left;
    width:98%;
    padding-left:2%
  }
  .entryApp .parkData li .isuservip font{
    position:absolute;
    top:-10px;
    right:-10px;
    color:#f00;
    font-weight:bold;
    border:2px dashed #ffd700;
    border-radius: 50%;
    width:23px;
    height:23px;
    background:#fff;
    font-size:12px;
    line-height:23px;
    text-align:center
  }
  .entryApp .none{
    font-size:14px;
    color:#6b6b6b;
    text-align:center;
    padding-top:70%;
  }
</style>